





























import _ from 'lodash'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import * as ApiPath from '@/tcw/constant/ApiPath'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import { TCWBadDataStructureError } from '@/plugins/TCWBaseError'
import { MShozoku } from '@/tcw/api/types'

class MShozokuDataGetComponent extends DataGetComponent<MShozoku[]> {}

@Component
export default class ShozokuSelectDialog extends Mixins(MShozokuDataGetComponent) {
  @Prop({ type: Boolean, default: true })
  private dialogOpen = false

  @Emit()
  private select(_record: MShozoku) {
    //
  }
  @Emit()
  private close() {
    //
  }

  private mShozokuList: MShozoku[] = []

  private get direction() {
    return this.isMobile ? 'btt' : 'rtl'
  }
  private get size() {
    return this.isMobile ? '90%' : '50%'
  }

  get apiPath(): string {
    return ApiPath.Paths.MShozoku.list
  }

  protected responseInitWebApi(response: MShozoku[]): void {
    if (_.isArray(response)) {
      this.mShozokuList = response.sort((a, b) => {
        const gyoushuA = a.gyoushuId ? a.gyoushuId : 0
        const gyoushuB = b.gyoushuId ? b.gyoushuId : 0
        if (gyoushuA !== gyoushuB) {
          return gyoushuA - gyoushuB
        }
        const idA = a.id ? a.id : 0
        const idB = b.id ? b.id : 0
        return idA - idB
      })
    } else {
      throw new TCWBadDataStructureError(
        'データ構造が不正です。システム管理者に問い合わせてください'
      )
    }
  }
}
